import { push } from '@lagunovsky/redux-react-router';
import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Alert, Button } from 'reactstrap';
import { ActionTokenParams } from '..';
import { myProfileNewsletterPath } from '../../../../screens/UserProfileScreen';
import { Section, SectionHeading } from '../../../common/Section';
import { actionTokenExecute } from '../actions';
import { actionTokenIsExecutedSelector } from '../selectors';

export const CancelNewsletter: FC<ActionTokenParams> = props => {
    const dispatch = useDispatch();

    const isExecuted = useSelector(actionTokenIsExecutedSelector);

    const onCancel = () => {
        dispatch(push('/'));
    };

    const onExecute = () => {
        if (props.atId && props.uId && props.secId) {
            dispatch(actionTokenExecute({ atId: props.atId, uId: props.uId, secId: props.secId }));
        }
    };

    return (
        <Section>
            <SectionHeading>Newsletter abbestellen</SectionHeading>
            <p>
                Mit dieser Aktion schalten Sie den Versand des Newsletter an Ihre Email-Adresse aus. Sie erhalten dann
                zukünftig keine Newsletter mehr.
            </p>
            {!isExecuted && (
                <>
                    <Button color="danger" className="me-3 mb-3" onClick={onExecute}>
                        Newsletter abbestellen
                    </Button>
                    <Button onClick={onCancel} color="success" className="mb-3">
                        Newsletter weiterhin erhalten
                    </Button>
                </>
            )}
            {isExecuted && (
                <Alert color="info">
                    Der Newsletter wurde abbestellt. Sie können diesen jederzeit wieder über ihr
                    <Link to={myProfileNewsletterPath()}>Profile</Link> abonnieren.
                </Alert>
            )}
        </Section>
    );
};
